import { createRootRoute, createRoute, createRouter, Outlet } from '@tanstack/react-router'
import { AdminDashboardPage } from './routes/AdminDashboardPage.js'
import { AnalyticsPage } from './routes/AnalyticsPage.js'
import { CertificatesPage } from './routes/CertificatesPage.js'
import { LoginPage } from './routes/LoginPage.js'
import { NotFoundPage } from './routes/NotFoundPage.js'
import { RenewalsPage } from './routes/RenewalsPage.js'
import { ReportsPage } from './routes/ReportsPage.js'
import { SettingsPage } from './routes/SettingsPage.js'
import { TeamPage } from './routes/TeamPage.js'

const rootRoute = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: NotFoundPage,
})

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
})

const dashboardRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: AdminDashboardPage,
})

const certificatesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/certificates',
  component: CertificatesPage,
})

const renewalsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/renewals',
  component: RenewalsPage,
})

const analyticsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/analytics',
  component: AnalyticsPage,
})

const reportsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reports',
  component: ReportsPage,
})

const teamRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/team',
  component: TeamPage,
})

const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings',
  component: SettingsPage,
})

const routeTree = rootRoute.addChildren([
  loginRoute,
  dashboardRoute,
  certificatesRoute,
  renewalsRoute,
  analyticsRoute,
  reportsRoute,
  teamRoute,
  settingsRoute,
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
